if (typeof jQuery !== 'undefined') jQuery(document).ready( function($) {
  const faqs = $('.faq');
  const faqCategories = $('.faq__category');
  const backgroundLightClasses = 'btn--outline';
  const backgroundDarkClasses = 'btn--outline-white';
  const tabActiveClass = 'toggle__btn--active';
  const questionActiveClass = 'faq-item__question--active';
  const answerActiveClass = 'faq-item__answer--active';
  const itemActiveClass = 'faq-item--active';
  const faqCategorylessQuestion = $('.faq-item__question').not('.faq__category .faq-item__question');
  const faqLocation = window.location.href;
  const faqHash = window.location.hash;
  const pageDeeplinks = document.querySelectorAll('a[href^="#"]');

  function getTabData(thisFaq) {
    const tabs = thisFaq.find('.faq__tabs').children();
    const tabCategory = thisFaq.find('.faq__category');
    const faqQuestion = thisFaq.find('.faq-item__question');
    const faqAnswer = thisFaq.find('.faq-item__answer');
    const faqBackgroundLight = thisFaq.hasClass('faq--light');

    const data = {
      tabs: tabs,
      tabCategory: tabCategory,
      faqQuestion: faqQuestion,
      faqAnswer: faqAnswer,
      faqBackgroundLight: faqBackgroundLight,
    };

    return data;
  }

  // display first category
  function showFirstCategory(tab, tabCategory) {
    tab.first().removeClass(backgroundLightClasses + ' ' + backgroundDarkClasses);
    tabCategory.first().show();
  }

  // show a specific category
  function showSpecificCategory(tab, category) {
    const thisFaq = tab.parents('.faq');
    const faqSection = getTabData(thisFaq);

    // reset tab classes for all section tabs
    faqSection.tabs.removeClass(tabActiveClass);

    // add active class for this tab
    tab.addClass(tabActiveClass);

    // hide any displayed categories and display appropriate category
    faqSection.tabCategory.hide();
    $('#tab-' + category).fadeIn('slow');

    // hide any displayed answers
    faqSection.faqQuestion.parent('.faq-item').removeClass(itemActiveClass);
    faqSection.faqQuestion.removeClass(questionActiveClass); 
    faqSection.faqAnswer.removeClass(answerActiveClass);
  }

  // show category when tab clicked
  function showCategory(e) {
    e.preventDefault();

    const thisTab = $(this);
    const id = thisTab.attr('id');

    showSpecificCategory(thisTab, id);
    segmentTrackModuleElementClicked(e, 'TOGGLE');
  }
  
  // track FAQ arrow clicks
  function faqTrack(faq) {
    const faqQuestion = faq.find('.faq-item__question-text').text();
    const properties = {
      location: faqLocation,
      faq_question: faqQuestion
    };

    // trigger segment event
    segment(
      'track',
      'FAQ Arrow Clicked',
      properties
    );

    // Analytics SDK double fire
    fireAnalyticsEvent(Track.WebItemClicked, {
      unique_id: 'faq_arrow_clicked',
      label: faqQuestion,
      element_type: 'ELEMENT_TYPE_BUTTON'
    });
  };

  // show answer
  function showAnswer(e, question) {
    if (!question.hasClass(questionActiveClass)) {
      faqTrack(question);
      
      question
        .addClass(questionActiveClass)
        .parent('.faq-item')
        .addClass(itemActiveClass)
        .find('.faq-item__answer')
        .addClass(answerActiveClass);
    }
  }

  // toggle question active and toggle answer displaying
  function toggleAnswer(e) {
    const faq = $(this);

    if (!faq.hasClass(questionActiveClass)) {
      faqTrack(faq);
    }

    faq
      .toggleClass(questionActiveClass)
      .parent('.faq-item')
      .toggleClass(itemActiveClass)
      .find('.faq-item__answer')
      .toggleClass(answerActiveClass);
  }

  function handleQuestionEnterKey(event) {
    if (event.key == "Enter") {
      $(event.target).trigger('click');
    }
  }

  // open question
  function checkForQuestion(faqHash) {
    const faqName = faqHash.substr(1);
    const anchor = $('span[id="' + faqName + '"]').first();
    const hashQuestion = anchor.siblings('.faq-item__question').first();
    const questionModuleIndex = hashQuestion.parents('.module').data('index');
    const questionCategory = questionModuleIndex + '-' + hashQuestion.data('category');
    const tab = $('#' + questionCategory);

    const properties = {
      url: faqLocation
    };

    if (hashQuestion.length) {
      showSpecificCategory(tab, questionCategory);
      showAnswer(null, hashQuestion);
      
      segment(
        'track',
        'FAQ Question Deeplinked',
        properties
      );

      // Analytics SDK double fire
      fireAnalyticsEvent(Track.WebItemClicked, {
        unique_id: 'faq_arrow_clicked',
        label: faqQuestion,
        element_type: 'ELEMENT_TYPE_BUTTON'
      });
    }
  }

  // Inits. changes are only reflected in the FAQ being interacted with
  for (var i = 0; i < faqCategories.length; i++) {
    const thisFaq = faqs.eq(i);
    const tabData = getTabData(thisFaq);
    tabData.tabs.on('click', showCategory);
    tabData.faqQuestion
      .on('click', toggleAnswer)
      .on('keydown', handleQuestionEnterKey);

    showFirstCategory(tabData.tabs, tabData.tabCategory);
  }

  // Init questions not inside categories (e.g. FAQ items on blog posts)
  faqCategorylessQuestion
    .on('click', toggleAnswer)
    .on('keydown', handleQuestionEnterKey);

  // Init scroll to question when hash in URL
  if (faqHash) checkForQuestion(faqHash);

  // Init scroll to question when FAQ deeplinks clicked on same page
  for (var d = 0; d < pageDeeplinks.length; d++) {
    pageDeeplinks[d].addEventListener('click', function (e) {
      const hash = e.target.hash;
      if (hash) checkForQuestion(hash);
    });
  }
});
